module.exports = __webpack_public_path__ + "img/logo_palace_resorts_green.b85cb9c5.svg";